class StickyAddtocart extends HTMLElement {
  // ─── Constants ──────────────────────────────────────────────────────────────
  static STORAGE_KEY = 'bundle_selected_ids';
  static SYNC_DELAY  = 1500;

  static classes = {
    loading: 'loading',
    hidden:  'hidden',
  };

  // ─── Lifecycle ──────────────────────────────────────────────────────────────
  constructor() {
    super();

    this.addButton        = document.querySelector('.action_button_area .addto_cart');
    this.stickyAddtocart  = this.querySelector('.sticky_addtocart');
    this.stickyViewCart   = this.querySelector('.sticky_viewcart');

    this._handleClick             = this._onAddToCartClick.bind(this);
    this._handleSelectionChanged  = this.syncVisibility.bind(this);
  }

  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this._init(), { once: true });
    } else {
      this._init();
    }
  }

  disconnectedCallback() {
    this.stickyAddtocart?.removeEventListener('click', this._handleClick);
    document.removeEventListener('bundle:selectionChanged', this._handleSelectionChanged);
  }

  // ─── Init ───────────────────────────────────────────────────────────────────
  _init() {
    this.stickyAddtocart?.addEventListener('click', this._handleClick);
    document.addEventListener('bundle:selectionChanged', this._handleSelectionChanged);
    this.syncVisibility();
  }

  // ─── Helpers ────────────────────────────────────────────────────────────────
  _getSelectedBundleIds() {
    try {
      const parsed = JSON.parse(localStorage.getItem(StickyAddtocart.STORAGE_KEY));
      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch {
      return [];
    }
  }

  async _getCartVariantIds() {
    try {
      const { items } = await fetch('/cart.js').then(r => r.json());
      return items.map(item => String(item.variant_id));
    } catch {
      return [];
    }
  }

  _allInCart(selectedIds, cartIds) {
    return selectedIds.length > 0 && selectedIds.every(id => cartIds.includes(id));
  }

  // ─── Visibility ─────────────────────────────────────────────────────────────
  async syncVisibility() {
    const selectedIds = this._getSelectedBundleIds();

    if (!selectedIds.length) {
      this._showAddToCart();
      return;
    }

    const cartIds   = await this._getCartVariantIds();
    const allInCart = this._allInCart(selectedIds, cartIds);

    allInCart ? this._showViewCart() : this._showAddToCart();
  }

  _showAddToCart() {
    this.stickyAddtocart?.classList.remove(StickyAddtocart.classes.hidden);
    this.stickyViewCart?.classList.add(StickyAddtocart.classes.hidden);
  }

  _showViewCart() {
    this.stickyAddtocart?.classList.add(StickyAddtocart.classes.hidden);
    this.stickyViewCart?.classList.remove(StickyAddtocart.classes.hidden);
  }

  // ─── Events ─────────────────────────────────────────────────────────────────
  _onAddToCartClick() {
    this.stickyAddtocart.classList.add(StickyAddtocart.classes.loading);
    this.addButton?.click();

    setTimeout(() => {
      this.stickyAddtocart.classList.remove(StickyAddtocart.classes.loading);
      this.syncVisibility();
    }, StickyAddtocart.SYNC_DELAY);
  }
}
customElements.define('sticky-addtocart', StickyAddtocart);